/* SESTO REVIEW UI - the one look every review on the website wears.
 *
 * Lorenzo, 27 October 2026, on /pages/reviews: "1.Add verified to all reviews s 2.should have
 * the same color background no white. 3. Hold same brand guidelines (font style. as other
 * website) Font is wrong style of stars is not the same". Then, 28 October: "ok now make sure
 * every section of the website that has review showing gets this UI update". So the card that
 * page draws is drawn here, once, for every place that shows reviews:
 *   - sections/sp-reviews-list.liquid - /pages/reviews, the shop's whole wall (mountPageList);
 *   - snippets/sp-reviews-look.liquid - the review band on every product page (mountBand);
 *   - sections/sp-dress-ring.liquid   - the wedding-dress-ring page's custom-work reviews.
 * Each of them renders snippets/sp-review-ui-style.liquid, which dresses these classes.
 *
 * A PRODUCT PAGE AND /pages/reviews READ OUR OWN COPY OF THE REVIEWS, IN SHOPIFY; the dress-ring
 * page still reads Fera. Lorenzo, 28 October 2026: "Yes, have the theme session switch .12's
 * product pages to read our Shopify copy instead of Fera." The copy is the product's
 * sesto_reviews metafields (reviews, rating, count), which our app refreshes every hour, handed
 * over 250 at a time by sections/sp-reviews-data.liquid (fetchOurs). Then, 29 October 2026, on the
 * new draft V5.13.15: "I have just created a new version of the theme. can you work on this and
 * update the reviews page". So /pages/reviews reads the shop's own lists of every approved review,
 * sesto_reviews.wall_1 to wall_5 (ourWall), and reads Fera only while those are not there. The
 * dress-ring page's chosen reviews ask Fera's PUBLIC api, with the key Fera itself puts in the
 * page, read each visit and written nowhere. A product page and Fera go through fetchPage()
 * below, which answers { total, rows } with rows shaped as toReview() (Fera) or ourReview()
 * (ours) make them; the wall's rows are shaped by ourReview() too.
 *
 * EVERY CARD CARRIES THE TICK, AND IT SAYS THE SAME ON EVERY REVIEW. Lorenzo, 28 October 2026:
 * "It should always say verified purchase not verifued google review". A Google review says it
 * too; the words are LABEL, in one place. Since 30 October they are "Verified", by a thin
 * outlined tick, as in his picture of that day (below).
 *
 * THE STARS ARE FERA'S OWN THIN TYPED STAR, gold #C3A976 on #DED8CF, the one star on every page
 * (Lorenzo, 28 October: "Make the changes for the star style everywhere including product
 * page"). Averages show the true figure, two decimals, never rounded up to 5 (avgText).
 *
 * THE NAME IS THE FIRST NAME AND THE SURNAME'S INITIAL, "Holly L.", where Fera's reviews show.
 * Lorenzo, 28 October: "Can you show the initial surbname like before on fera?" Fera's own names
 * are already written that way for most (344 of its newest 600); the 230 that came from a
 * spreadsheet import only ever had a first name, and show that. OUR OWN COPY keeps first names
 * only (all 2,964 are one word), so a product page shows "Holly", as it is stored.
 *
 * THE REVIEWER'S OWN PICTURE SHOWS WHERE THERE IS ONE. Lorenzo, the same message: "Also show
 * image of person Icon if available". Otherwise the circle with their first letter, in gold
 * since 30 October (below).
 * Measured 28 October on Fera's newest 600 reviews: only the 343 Google ones carry a picture
 * (customer_avatar_url); the rest carry Fera's made-up letter (equal to
 * default_customer_avatar_url), which is skipped. Of the 343, 153 were Google's OWN letter
 * circles, not pictures of anyone, in bright colours beside our pale ones; those are found by
 * looking at the picture (isLetterCircle) and skipped too. A picture that cannot be loaded or
 * looked at leaves the letter. Our copy carries no place, so a product page shows no pin.
 * ITS GOOGLE PICTURES COME FROM OUR OWN STORAGE. Lorenzo, 28 October 2026: "Yes, bring the
 * Google profile pictures back: copy them into our own storage, add them to the Shopify copy,
 * and show them on the review cards on V5.13.12." Shopify Editor Reviews copies them and fills
 * the sesto_review field `avatar`; ourReview() hands it to the same picture code as Fera's, so
 * Google's own letter circles are dropped here too. Until the field is filled it is empty and
 * the card shows the letter.
 *
 * EVERY CARD SHOWS THE DAY IT WAS WRITTEN, "Oct 21, 2026", never "1W AGO". Lorenzo, 28 October:
 * "Instead of 1 w ago can you just always put the date?". In the visitor's own time zone.
 *
 * WHEREVER THIS CANNOT DRAW, FERA'S OWN LIST COMES BACK. Each place hides Fera's list only
 * while this is fetching and once it has drawn; no key, an api error or a timeout lifts the
 * hiding and leaves the page as it was before.
 *
 * Shopify Reviews Page Theme, 28 October 2026. Claimed in issue #49.
 *
 * LORENZO'S LIST OF 30 OCTOBER 2026, on /pages/reviews, draft V5.13.16 (issue #59):
 *   "Filter and remove duplicate reviews e.g. Etsy Anastasia oct 23rd" - the wall shows a
 *   review ONCE when the first name, the stars and the words are the same (sameWords). Etsy
 *   records a review once per item, so a buyer of two size kits has two alike, 11 seconds apart,
 *   and a Fera copy can sit beside its Etsy original months apart. Measured that day on the
 *   published reviews: 51 such groups with words, all plainly one review. A review with no words
 *   is never folded, because two people of one first name can both leave five stars. Only the
 *   wall: a product page shows that product's own, where each twin sits on its own ring's page.
 *   The database keeps every row, so the count in the bar above still counts them.
 *   "Make icons with no image, branded and consistent." - one circle for everybody without a
 *   picture, instead of eight pastels picked by the name. Then, with a picture of a card: "Change
 *   the looks to this one the icon changed as well as the verified badge." So the circle is a thin
 *   gold ring around a dark letter on the card's own colour, and the badge a thin gold ring with a
 *   tick and "Verified", in the deeper gold measured off his picture (snippets/sp-review-ui-style).
 *   "Collapse long reviews" - the wall's cards are cut too, with "Read more", to the lines
 *   sections/sp-reviews-list.liquid sets (--sp-rev-lines).
 *   Then, with a picture of the button under the list: "The review page should show pagination
 *   not view more" - the wall is ten to a page with numbered pages (mountPageList), the pager a
 *   product page's band already had.
 * Shopify Editor (Office), 30 October 2026.
 *
 * 1 November 2026, Lorenzo: "Yes, build our own Write a review form on draft V5.13.18."
 *   OUR OWN FORM IS NOW IN THIS FILE, at the foot, with the one switch that turns the
 *   button on - WRITE_A_REVIEW, just below. It is a dialog over the page, so nothing on a
 *   ring page moves when it opens, and it writes through the edge function reviews-submit,
 *   which is NOT DEPLOYED YET. On an unpublished theme the button shows anyway so the form
 *   can be looked at in preview; on the published theme only that one line decides.
 *   sections/sp-reviews-summary.liquid prints /pages/reviews' button and this file decides
 *   whether it shows, so the switch is in one place and not two.
 * Reviews (Photography PC), 1 November 2026.
 */
(function () {
  'use strict';
  if (window.SpReviewUI) return;

  // The words by the tick, in one place. Every review says them, Google ones too.
  var LABEL = 'Verified';
  // "WRITE A REVIEW" AND OUR OWN FORM, BEHIND ONE SWITCH, ON ONE LINE.
  //
  // Lorenzo, 1 November 2026: "Yes, build our own Write a review form on draft V5.13.18."
  // Until 1 November the button pressed Fera's hidden link, so the form was always Fera's;
  // Fera is being uninstalled and the button was hidden on his word ("hide Write a review
  // until we have our own form"). The form below is ours. It writes through the edge
  // function reviews-submit, WHICH IS NOT DEPLOYED YET.
  //
  // THIS IS THE LINE THAT TURNS IT ON. Turn it to true once reviews-submit is live, and
  // nothing else needs touching - the product band and /pages/reviews both read it.
  var WRITE_A_REVIEW = true; // turned on 2 November 2026, on Lorenzo's word, on draft V5.13.18
  //
  // ON A DRAFT THE BUTTON SHOWS ANYWAY, so Lorenzo can look at the form in preview while
  // the door is still not deployed; the form then says plainly that it could not be sent.
  // On the PUBLISHED theme only the line above decides. A page with no Shopify.theme at
  // all is treated as the published one, so an unreadable role keeps the button hidden
  // rather than showing it.
  var FORM_DOOR = 'https://ofaevaqsuppeqtrtypra.supabase.co/functions/v1/reviews-submit';

  function themeIsLive() {
    var t = window.Shopify && window.Shopify.theme;
    return !t || String(t.role || 'main') === 'main';
  }
  function writeOn() { return WRITE_A_REVIEW || !themeIsLive(); }
  // The flat colours Google paints its letter circles in, read off them on 28 October.
  // A letter circle in a colour not listed here would show as a picture, so add it here.
  var GOOGLE_LETTER = [
    [3, 136, 210], [0, 137, 123], [93, 106, 192], [0, 152, 167], [239, 108, 0], [172, 71, 187],
    [81, 45, 169], [194, 24, 91], [123, 31, 162], [119, 145, 157], [190, 54, 11], [0, 77, 64],
    [103, 159, 56], [0, 87, 155], [93, 65, 56], [236, 65, 122], [52, 105, 30], [69, 90, 99],
    [243, 81, 29], [142, 109, 99], [125, 87, 193]
  ];
  var FIVE = '\u2605\u2605\u2605\u2605\u2605';
  // A thin ring with a tick in it, in the colour of the words beside it (currentColor).
  var TICK = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="7.3" fill="none" stroke="currentColor" stroke-width="1.2"/><path d="M5.1 8.2l2 2 3.8-4" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var PIN = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2a7 7 0 0 0-7 7c0 5.2 7 13 7 13s7-7.8 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/></svg>';
  var PLAY = '<span class="sp-rv__play"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z"/></svg></span>';

  /* ---- The data: Fera's public api today, ours on switch day. ---- */

  function feraKey() {
    var f = window.fera;
    var k = f && f.api && f.api._config && f.api._config.store_pk;
    if (k) return k;
    // Fera's own requests carry the key in their address; take it from there if its config
    // has not been set yet. Read, never written down.
    var es;
    try { es = performance.getEntriesByType('resource'); } catch (e) { return null; }
    for (var i = es.length - 1; i >= 0; i--) {
      var n = es[i].name;
      if (!n || n.indexOf('fera.ai') < 0 || n.indexOf('public_key=') < 0) continue;
      try { var p = new URL(n).searchParams.get('public_key'); if (p) return p; } catch (e) {}
    }
    return null;
  }

  function waitForKey(ms) {
    return new Promise(function (resolve) {
      if (feraKey()) return resolve(feraKey());
      var stop = Date.now() + (ms || 15000);
      var t = setInterval(function () {
        var k = feraKey();
        if (k || Date.now() > stop) { clearInterval(t); resolve(k || null); }
      }, 400);
    });
  }

  /* Our own copy: the product's sesto_reviews metafields, which sections/sp-reviews-data.liquid
   * prints for the product in the address, 250 to a request (Shopify's most for a list of
   * references; a plain loop stops at 50). It is asked for through the Section Rendering API, so
   * it comes from the same theme and the same product as the page. Each 250 is fetched once a
   * visit and shared, so the band's first three, its pages and its exact average cost one request
   * for most products and two for The Quest (332). */
  var OUR_PER = 250;
  var ourPages = {};

  function ourProduct(productId) {
    var p = window.SpReviewUIProduct;
    return p && p.ours && p.handle && String(p.id) === String(productId) ? p : null;
  }

  function ourPage(p, n) {
    var key = p.handle + '/' + n;
    if (!ourPages[key]) {
      // A metafield list is paged by a parameter of its own, not ?page=; page 1 names it, and
      // says how many pages there are (null: past the last, so nothing to ask for).
      var param = n > 1 ? ourPage(p, 1).then(function (d) { return n > (Number(d.pages) || 1) ? null : (d.param || 'page'); }) : Promise.resolve('');
      ourPages[key] = param.then(function (name) {
        if (name === null) return { total: null, page: n, rows: [] };
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var url = root + 'products/' + encodeURIComponent(p.handle) + '?section_id=sp-reviews-data';
        if (name) url += '&' + encodeURIComponent(name) + '=' + n;
        // In a theme preview the section has to come from the theme being previewed.
        var preview = null;
        try { preview = new URLSearchParams(location.search).get('preview_theme_id'); } catch (e) {}
        if (preview) url += '&preview_theme_id=' + encodeURIComponent(preview);
        return fetch(url, { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('our reviews answered ' + r.status);
          return r.text();
        }).then(function (text) {
          var el = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-sp-rv-data]');
          var d = el && JSON.parse(el.getAttribute('data-sp-rv-data'));
          // An answer for another page than the one asked for is refused, never shown twice.
          if (!d || !Array.isArray(d.rows) || Number(d.page) !== n) throw new Error('unexpected answer');
          return d;
        });
      });
      // A failed ask is not kept, so pressing again asks again.
      ourPages[key].catch(function () { delete ourPages[key]; });
    }
    return ourPages[key];
  }

  function fetchOurs(p, q) {
    var limit = q.limit || 10, from = ((q.page || 1) - 1) * limit;
    var first = Math.floor(from / OUR_PER) + 1, last = Math.floor((from + limit - 1) / OUR_PER) + 1, jobs = [];
    for (var n = first; n <= last; n++) jobs.push(ourPage(p, n));
    return Promise.all(jobs).then(function (pages) {
      var rows = [], total = null;
      pages.forEach(function (d) {
        rows = rows.concat(d.rows);
        if (d.total != null && !isNaN(Number(d.total))) total = Number(d.total);
      });
      var skip = from - (first - 1) * OUR_PER;
      return { total: total, rows: rows.slice(skip, skip + limit).map(ourReview) };
    });
  }

  // WHERE THE REVIEWS COME FROM, except /pages/reviews' own lists (ourWall, below).
  // q: { page (from 1), limit, productId, ids }.
  // Newest first. Answers { total (or null), rows }, rows shaped as toReview() or ourReview()
  // make them. The product page's own product comes from our copy, anything else from Fera.
  function fetchPage(q) {
    q = q || {};
    var ours = q.productId ? ourProduct(q.productId) : null;
    if (ours) return fetchOurs(ours, q);
    var key = feraKey();
    if (!key) return Promise.reject(new Error('no Fera key on the page'));
    var url = 'https://api2.fera.ai/v2/public/reviews.json?public_key=' + encodeURIComponent(key) +
      '&limit=' + (q.limit || 10) + '&page=' + (q.page || 1);
    if (q.productId) url += '&product_id=' + encodeURIComponent(q.productId);
    if (q.ids && q.ids.length) url += '&ids=' + q.ids.map(encodeURIComponent).join(',');
    return fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('Fera answered ' + r.status);
      var t = parseInt(r.headers.get('total-count'), 10);
      return r.json().then(function (rows) {
        if (!Array.isArray(rows)) throw new Error('unexpected answer');
        return { total: isNaN(t) ? null : t, rows: rows.map(toReview) };
      });
    });
  }

  function toReview(d) {
    var media = [];
    (d.media || []).forEach(function (m) {
      if (m && m.url && (m.type === 'photo' || m.type === 'video')) media.push({ type: m.type, url: m.url, thumb: m.thumbnail_url || (m.type === 'photo' ? m.url : '') });
    });
    if (!media.length) {
      (d.photos || []).forEach(function (u) { u = typeof u === 'string' ? u : (u && (u.url || u.thumbnail_url)); if (u) media.push({ type: 'photo', url: u, thumb: u }); });
      (d.videos || []).forEach(function (u) { u = typeof u === 'string' ? u : (u && u.url); if (u) media.push({ type: 'video', url: u, thumb: '' }); });
    }
    return {
      id: d.id != null ? String(d.id) : '',
      rating: Math.max(0, Math.min(5, Math.round(Number(d.rating) || 0))),
      heading: clean(d.heading),
      body: clean(d.body),
      when: d.created_at || d.date || null,
      name: shownName(d.customer_name),
      location: clean(d.customer_location),
      // Fera fills customer_avatar_url with its own made-up letter when there is no picture.
      avatar: d.customer_avatar_url && d.customer_avatar_url !== d.default_customer_avatar_url ? clean(d.customer_avatar_url) : '',
      google: d.original_source === 'google' || d.channel_code === 'google',
      product: d.type === 'product' && d.product && d.product.name ? clean(d.product.name) : '',
      media: media,
      reply: clean(d.store_reply)
    };
  }

  // A review from our copy, in the same shape. Its heading is drawn where Fera's was. Its
  // picture is the reviewer's own when our copy has one (`avatar`, Google reviews), else the
  // letter. Its product name, place and the shop's reply come only on the shop's wall
  // (/pages/reviews), where our copy carries them (`product`, `location`, `reply`); a product
  // page's rows have none of the three, so its cards show none of those lines.
  // A video among the photos is known by its file name.
  var VIDEO_FILE = /\.(mp4|mov|m4v|webm)(?:[?#]|$)/i;
  function ourReview(d) {
    var media = [];
    (d.photos || []).forEach(function (u) {
      u = clean(u);
      if (u) media.push(VIDEO_FILE.test(u) ? { type: 'video', url: u, thumb: '' } : { type: 'photo', url: u, thumb: u });
    });
    var at = Number(d.at);
    return {
      id: d.id != null ? String(d.id) : '',
      rating: Math.max(0, Math.min(5, Math.round(Number(d.rating) || 0))),
      heading: clean(d.title),
      body: clean(d.body),
      when: at ? new Date(at * 1000).toISOString() : null,
      name: shownName(d.author),
      location: clean(d.location),
      avatar: clean(d.avatar),
      google: d.source === 'google',
      product: clean(d.product),
      media: media,
      reply: clean(d.reply)
    };
  }

  /* ---- The look. ---- */

  function clean(v) { return v == null ? '' : String(v).trim(); }
  // "Holly Lane", "Holly L." and "Holly" become "Holly L.", "Holly L." and "Holly". A last word
  // with no letter in it, such as Fera's "Pam (.", gives no initial.
  function shownName(v) {
    var w = clean(v).split(/\s+/).filter(Boolean);
    if (!w.length) return 'Customer';
    var initial = w.length > 1 ? (w[w.length - 1].match(/[A-Za-z\u00C0-\u024F]/) || [''])[0] : '';
    return w[0] + (initial ? ' ' + initial.toUpperCase() + '.' : '');
  }
  function esc(v) {
    return String(v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function dateText(iso) {
    var t = Date.parse(iso);
    if (isNaN(t)) return '';
    var d = new Date(t);
    return MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  }

  // Google's letter circle: one flat colour from GOOGLE_LETTER fills the ring between the letter
  // and the edge. The bottom right is left out, where Google puts its Local Guide badge. Measured
  // 28 October with this code on all 343 Google pictures: the 153 letter circles had 67% to 100%
  // of that ring in one of these colours (152 of them all of it), the 190 real pictures 7% at
  // most, and each was checked by eye. 30% sits in that gap.
  function isLetterCircle(img) {
    var w = img.naturalWidth, h = img.naturalHeight;
    if (!w || !h) return true;
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var x = c.getContext('2d');
    x.drawImage(img, 0, 0);
    var p = x.getImageData(0, 0, w, h).data;
    var cx = w / 2, cy = h / 2, r = Math.min(w, h) / 2;
    var hits = GOOGLE_LETTER.map(function () { return 0; }), n = 0;
    for (var y = 0; y < h; y++) {
      for (var i = 0; i < w; i++) {
        var dx = i + 0.5 - cx, dy = y + 0.5 - cy, d = Math.sqrt(dx * dx + dy * dy) / r;
        if (d < 0.62 || d > 0.88 || (dx > 0 && dy > 0)) continue;
        n++;
        var j = (y * w + i) * 4;
        for (var k = 0; k < GOOGLE_LETTER.length; k++) {
          var g = GOOGLE_LETTER[k];
          if (Math.abs(p[j] - g[0]) <= 6 && Math.abs(p[j + 1] - g[1]) <= 6 && Math.abs(p[j + 2] - g[2]) <= 6) { hits[k]++; break; }
        }
      }
    }
    return n > 0 && Math.max.apply(null, hits) / n >= 0.3;
  }

  // The picture sits hidden over the letter and shows only once it has loaded and is a real one.
  // load and error do not bubble, so they are caught on the way down.
  document.addEventListener('load', function (e) {
    var img = e.target;
    if (!img.matches || !img.matches('img[data-sp-rv-face]')) return;
    var real = false;
    try { real = !isLetterCircle(img); } catch (err) {}
    if (real) img.parentNode.classList.add('sp-rv__face--pic');
    else img.parentNode.removeChild(img);
  }, true);
  document.addEventListener('error', function (e) {
    var img = e.target;
    if (img.matches && img.matches('img[data-sp-rv-face]') && img.parentNode) img.parentNode.removeChild(img);
  }, true);

  // An average as it really is: two decimals, never rounded up to 5. 4.964 shows 4.96, 4.996
  // shows 4.99, and 5.0 only when every review is five stars. Lorenzo, 30 October 2026: "Lets
  // show the true average", replacing his 28 October rule ("Show the average rounded to one
  // decimal like Fera, so The Quest says 5.0"), under which the whole shop's 4.964 read 5.0.
  // Math.round, not a bare toFixed(2), which rounds some halves down. The stars are filled to
  // the exact average.
  function avgText(avg) {
    var a = Math.max(0, Math.min(5, Number(avg) || 0));
    if (a >= 5) return '5.0';
    var c = Math.round(a * 100);
    if (c >= 500) c = 499;
    return (c / 100).toFixed(2);
  }

  // Five typed stars, Fera's own thin character, a gold row clipped to the rating over a grey
  // row, the way Fera draws its own. Lorenzo, 28 October: "Make the changes for the star style
  // everywhere".
  function starRow(cls, fill, label) {
    return '<span class="sp-rv__avg' + (cls ? ' ' + cls : '') + '" role="img" aria-label="' + esc(label) + '">' +
      '<span class="sp-rv__avg-base" aria-hidden="true">' + FIVE + '</span>' +
      '<span class="sp-rv__avg-fill" aria-hidden="true" style="width:' + (Math.max(0, Math.min(1, fill)) * 100).toFixed(2) + '%">' + FIVE + '</span></span>';
  }

  function starsHTML(n) {
    return starRow('sp-rv__stars', n / 5, n + ' out of 5 stars');
  }

  // Five stars filled to an average, as the summary bar on /pages/reviews draws them.
  function avgStarsHTML(avg) {
    var a = Math.max(0, Math.min(5, Number(avg) || 0));
    return starRow('', a / 5, avgText(a) + ' out of 5 stars');
  }

  // o: { product: show "Product: Name", clamp: cut the words to --sp-rev-lines with "Read more",
  //      photoCap: show this many photos until "Read more" (0 = all), readMore: its words }
  function cardHTML(r, o) {
    o = o || {};
    var cap = o.photoCap || 0;
    var extra = cap > 0 && r.media.length > cap;
    var h = '<article class="sp-rv__card"' + (r.id ? ' data-sp-rv-id="' + esc(r.id) + '"' : '') + '>';
    h += '<div class="sp-rv__top">' + starsHTML(r.rating);
    if (r.when) h += '<time class="sp-rv__date" datetime="' + esc(r.when) + '">' + dateText(r.when) + '</time>';
    h += '</div>';
    if (r.heading) h += '<h3 class="sp-rv__heading">' + esc(r.heading) + '</h3>';
    if (r.body) h += '<p class="sp-rv__body"' + (o.clamp ? ' data-sp-rv-clamp' : '') + '>' + esc(r.body) + '</p>';
    if (o.clamp || extra) h += '<button type="button" class="sp-rv__read" hidden' + (extra ? ' data-sp-rv-extra' : '') + '>' + esc(o.readMore || 'Read more') + '</button>';
    if (r.media.length) {
      h += '<div class="sp-rv__media">';
      r.media.forEach(function (m, i) {
        var label = (m.type === 'video' ? 'Play the video' : 'Open the photo') + ' from ' + r.name;
        h += '<button type="button" class="sp-rv__thumb' + (cap > 0 && i >= cap ? ' sp-rv__thumb--extra' : '') + '" data-type="' + m.type + '" data-url="' + esc(m.url) + '" aria-label="' + esc(label) + '">';
        if (m.thumb) h += '<img src="' + esc(m.thumb) + '" alt="" loading="lazy" decoding="async">';
        if (m.type === 'video') h += PLAY;
        h += '</button>';
      });
      h += '</div>';
    }
    if (o.product && r.product) h += '<p class="sp-rv__product">Product: <i>' + esc(r.product) + '</i></p>';
    h += '<div class="sp-rv__who"><span class="sp-rv__face" aria-hidden="true">' + esc(r.name.charAt(0).toUpperCase());
    if (r.avatar) h += '<img src="' + esc(r.avatar) + '" alt="" crossorigin="anonymous" loading="lazy" decoding="async" data-sp-rv-face>';
    h += '</span><div>';
    h += '<div class="sp-rv__name-row"><span class="sp-rv__name">' + esc(r.name) + '</span><span class="sp-rv__verified">' + TICK + esc(LABEL) + '</span></div>';
    if (r.location) h += '<div class="sp-rv__loc">' + PIN + '<span>' + esc(r.location) + '</span></div>';
    h += '</div></div>';
    if (r.reply) h += '<div class="sp-rv__reply"><p class="sp-rv__reply-by">Sesto Synergy replied</p><p class="sp-rv__reply-text">' + esc(r.reply) + '</p></div>';
    return h + '</article>';
  }

  // "Read more" only where the words really run past the clamp, or photos are held back -
  // measured on the card as drawn, so it must be on the page (not display: none) when this runs.
  function measureClamps(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.sp-rv__card:not([data-sp-rv-measured])'), function (card) {
      if (!card.offsetParent) return;
      card.setAttribute('data-sp-rv-measured', '');
      var btn = card.querySelector('.sp-rv__read');
      if (!btn) return;
      var body = card.querySelector('.sp-rv__body[data-sp-rv-clamp]');
      var cut = !!body && body.scrollHeight - body.clientHeight > 2;
      if (body && !cut) body.removeAttribute('data-sp-rv-clamp');
      btn.hidden = !(cut || btn.hasAttribute('data-sp-rv-extra'));
    });
  }

  // Photos and videos open over the page; a click outside, the cross or Escape closes them.
  var lb = null;
  function openMedia(type, url) {
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'sp-rv-lb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Customer photo');
      lb.innerHTML = '<button type="button" class="sp-rv-lb__close" aria-label="Close">&times;</button><div class="sp-rv-lb__item"></div>';
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('.sp-rv-lb__close')) closeMedia(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb && !lb.hidden) closeMedia(); });
      document.body.appendChild(lb);
    }
    lb.querySelector('.sp-rv-lb__item').innerHTML = type === 'video'
      ? '<video src="' + esc(url) + '" controls autoplay playsinline></video>'
      : '<img src="' + esc(url) + '" alt="Customer photo">';
    lb.hidden = false;
    lb.querySelector('.sp-rv-lb__close').focus();
  }
  function closeMedia() {
    if (!lb) return;
    lb.hidden = true;
    lb.querySelector('.sp-rv-lb__item').innerHTML = '';
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.sp-rv__thumb');
    if (t) { openMedia(t.getAttribute('data-type'), t.getAttribute('data-url')); return; }
    var b = e.target.closest && e.target.closest('.sp-rv__read');
    if (b) {
      var card = b.closest('.sp-rv__card');
      var body = card && card.querySelector('.sp-rv__body');
      if (body) body.removeAttribute('data-sp-rv-clamp');
      if (card) card.classList.add('sp-rv__card--open');
      b.hidden = true;
    }
  });

  /* ---- /pages/reviews: the whole wall, newest first, 10 to a page, with numbered pages. ----
   * Lorenzo, 30 October 2026, with a picture of the button under the list: "The review page
   * should show pagination not view more". So the wall has the numbered pages a product page's
   * band has from 769px (pagerHTML), on a phone too; a page replaces the cards and brings the
   * top of the list back into view.
   * From our own copy when the page carries it (ourWall), else from Fera (feraWall), as before.
   * Each answers page(p) with { page, pages, rows }: that page's ten cards and how many pages
   * there are, a page past the last being brought back to the last. */

  var WALL_PRESS = 10;

  // "< 1 ... 4 5 6 ... 20 >": the first, the last, and the pages either side of the one shown.
  function pagerHTML(page, pages) {
    var want = {}, out = [], last = 0;
    [1, pages, page - 1, page, page + 1].forEach(function (p) { if (p >= 1 && p <= pages) want[p] = 1; });
    Object.keys(want).map(Number).sort(function (a, b) { return a - b; }).forEach(function (p) {
      if (last && p - last > 1) out.push('<span class="sp-rv__gap" aria-hidden="true">&hellip;</span>');
      out.push('<button type="button" class="sp-rv__page' + (p === page ? ' is-on' : '') + '" data-page="' + p + '"' + (p === page ? ' aria-current="page"' : '') + ' aria-label="Page ' + p + '">' + p + '</button>');
      last = p;
    });
    return '<button type="button" class="sp-rv__page sp-rv__page--arrow" data-page="' + (page - 1) + '" aria-label="Previous page"' + (page <= 1 ? ' disabled' : '') + '>&lsaquo;</button>' +
      out.join('') +
      '<button type="button" class="sp-rv__page sp-rv__page--arrow" data-page="' + (page + 1) + '" aria-label="Next page"' + (page >= pages ? ' disabled' : '') + '>&rsaquo;</button>';
  }

  function mountPageList(root) {
    if (!root || root.getAttribute('data-sp-rv-bound')) return;
    root.setAttribute('data-sp-rv-bound', '1');
    var html = document.documentElement;
    var list = root.querySelector('.sp-rl__list');
    var status = root.querySelector('.sp-rl__status');
    var pager = root.querySelector('.sp-rv__pager');
    var error = root.querySelector('.sp-rl__error');
    var cur = 1, busy = false, drawn = false;
    // Our copy learns the true number of pages once it has read the whole wall.
    var src = ourWall(root, function () { if (drawn) drawPager(src.pages()); }) || feraWall();

    function giveUp() { html.classList.remove('sp-rl-wait'); if (status) status.hidden = true; }
    setTimeout(function () { if (!drawn) giveUp(); }, 16000);

    function drawPager(pages) {
      pager.hidden = pages < 2;
      pager.innerHTML = pages < 2 ? '' : pagerHTML(cur, pages);
    }

    // Long words are cut with "Read more" (Lorenzo, 30 October: "Collapse long reviews"); a card
    // is measured once it is on the page.
    function show(res) {
      cur = res.page;
      list.innerHTML = res.rows.map(function (r) { return cardHTML(r, { product: true, clamp: true }); }).join('');
      drawPager(res.pages);
      measureClamps(list);
    }

    src.page(1).then(function (res) {
      if (!res.rows.length) throw new Error('no reviews');
      show(res);
      drawn = true;
      status.hidden = true;
      html.classList.add('sp-rl-on');
      html.classList.remove('sp-rl-wait');
      measureClamps(list);
      // The rest of the wall is read once the reader comes near the pages, so that the last
      // number is the true one by then and any page opens at once.
      if (!src.warm) return;
      if (!('IntersectionObserver' in window)) return src.warm();
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); src.warm(); }
      }, { rootMargin: '1200px 0px' });
      io.observe(pager.parentNode);
    }).catch(giveUp);

    pager.addEventListener('click', function (e) {
      var b = e.target.closest('.sp-rv__page');
      if (!b || b.disabled || busy) return;
      var p = parseInt(b.getAttribute('data-page'), 10);
      if (!p || p === cur) return;
      busy = true;
      error.hidden = true;
      root.classList.add('sp-rl--busy');
      src.page(p).then(function (res) {
        show(res);
        // Back to the first card of the new page, and the keyboard with it.
        var top = list.getBoundingClientRect().top;
        if (top < 0) window.scrollTo(0, top + window.pageYOffset - 24);
        try { list.focus({ preventScroll: true }); } catch (x) {}
      }).catch(function () {
        error.hidden = false;
      }).then(function () {
        busy = false;
        root.classList.remove('sp-rl--busy');
      });
    });
  }

  // Fera's public api, a page at a time, as the page read it before our copy.
  function feraWall() {
    var ready = null;
    return {
      page: function (p) {
        if (!ready) ready = waitForKey(15000);
        return ready.then(function (key) {
          if (!key) throw new Error('no key');
          return fetchPage({ page: p, limit: WALL_PRESS });
        }).then(function (res) {
          var pages = res.total != null ? Math.max(1, Math.ceil(res.total / WALL_PRESS)) : p + (res.rows.length < WALL_PRESS ? 0 : 1);
          return { page: p, pages: pages, rows: res.rows };
        });
      }
    };
  }

  /* Our own copy: every approved review, product and shop alike, newest first, in the shop's
   * metafields sesto_reviews.wall_1 to wall_5 (1,024 at most each: the newest 1,024, the next
   * 1,024, and so on; one not needed yet is empty and is passed over), written by Shopify Editor
   * Reviews. sections/sp-reviews-list.liquid prints the first 50 into the page
   * (data-sp-rv-wall), so the first five pages need no request. The rest is each list read 250
   * at a time through its own section, named by the page in order (data-sp-rv-wall-sections),
   * page 1 of each list naming the parameter for the rest: every list's page 1 at once, then the
   * rest of every list at once (about 350 KB in all, a second or two), added in the wall's own
   * order whatever order they come back in. Until it is all in, the number of pages is the bar's
   * count (data-sp-rv-wall-count, sesto_reviews.wall_summary), which counts a review held twice
   * twice, so the last number can only come down when the true one is known. A review already
   * shown is never shown again, so a list rewritten while someone is reading cannot repeat one
   * at the seam. Without the first 50 this answers null, and Fera is read. */
  function wallPage(name, n, param) {
    var url = location.pathname + '?section_id=' + encodeURIComponent(name);
    if (n > 1) url += '&' + encodeURIComponent(param || 'page') + '=' + n;
    // In a theme preview the section has to come from the theme being previewed.
    var preview = null;
    try { preview = new URLSearchParams(location.search).get('preview_theme_id'); } catch (e) {}
    if (preview) url += '&preview_theme_id=' + encodeURIComponent(preview);
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('our reviews answered ' + r.status);
      return r.text();
    }).then(function (text) {
      var el = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-sp-rv-data]');
      var d = el && JSON.parse(el.getAttribute('data-sp-rv-data'));
      // An answer for another page than the one asked for is refused, never shown twice.
      if (!d || !Array.isArray(d.rows) || Number(d.page) !== n) throw new Error('unexpected answer');
      return d;
    });
  }

  // The same first name, stars and words make one review on the wall, however many rows hold it
  // (Lorenzo, 30 October: "Filter and remove duplicate reviews"). The words are compared without
  // case or extra spaces. No words, no key: a review with stars only is never folded.
  function sameWords(d) {
    var words = clean(d.body).toLowerCase().replace(/\s+/g, ' ');
    if (!words) return '';
    return clean(d.author).toLowerCase() + '|' + Math.round(Number(d.rating) || 0) + '|' + words;
  }

  function ourWall(root, changed) {
    var start = null;
    try { start = JSON.parse(root.getAttribute('data-sp-rv-wall') || 'null'); } catch (e) {}
    if (!start || !Array.isArray(start.rows) || !start.rows.length) return null;
    var names = (root.getAttribute('data-sp-rv-wall-sections') || '').split(',').filter(Boolean);
    var guess = Number(root.getAttribute('data-sp-rv-wall-count')) || 0;
    var all = [], seen = {}, said = {}, waiters = [], loading = null, whole = !names.length;
    var lists = names.map(function (name) { return { name: name, pages: null, param: '', got: [] }; });
    var at = { list: 0, page: 0 };   // the next page to add, in the wall's own order

    // Newest first, so the newest of a duplicate is the one shown.
    function add(rows) {
      rows.forEach(function (d) {
        if (!d) return;
        var id = d.id != null ? String(d.id) : '';
        if (id && seen[id]) return;
        if (id) seen[id] = 1;
        var w = sameWords(d);
        if (w && said[w]) return;
        if (w) said[w] = 1;
        all.push(ourReview(d));
      });
    }
    add(start.rows);

    // Pages come back in any order and are added in the wall's: list by list, page by page.
    // Whoever is waiting for enough cards is answered as soon as they are in.
    function flush() {
      while (at.list < lists.length) {
        var L = lists[at.list];
        if (L.pages == null) break;
        if (at.page >= L.pages) { at.list += 1; at.page = 0; continue; }
        if (!L.got[at.page]) break;
        add(L.got[at.page]);
        L.got[at.page] = [];   // added; its rows are not needed again
        at.page += 1;
      }
      if (at.list >= lists.length && !whole) { whole = true; changed(); }
      waiters = waiters.filter(function (w) {
        if (all.length < w.need && !whole) return true;
        w.done();
        return false;
      });
    }

    function read(L, n) {
      return wallPage(L.name, n, L.param).then(function (d) {
        if (n === 1 && L.pages == null) { L.pages = Number(d.pages) || 0; L.param = d.param || ''; }
        L.got[n - 1] = d.rows;
        flush();
      });
    }

    // Read the whole wall: every list's page 1 at once, then the rest of every list at once. A
    // page that fails is left out, the cards waiting on it are refused, and it is asked again
    // the next time.
    function load() {
      if (whole) return Promise.resolve();
      if (loading) return loading;
      var failed = null;
      function keep(job) { return job.catch(function (e) { failed = e; }); }
      loading = Promise.all(lists.map(function (L) {
        return keep(L.pages == null ? read(L, 1) : Promise.resolve()).then(function () {
          var jobs = [];
          for (var n = 2; L.pages != null && n <= L.pages; n++) if (!L.got[n - 1]) jobs.push(keep(read(L, n)));
          return Promise.all(jobs);
        });
      })).then(function () {
        loading = null;
        if (whole) return;
        var e = failed || new Error('the wall could not be read'), w = waiters;
        waiters = [];
        w.forEach(function (x) { x.fail(e); });
        throw e;
      });
      return loading;
    }

    // Until the whole wall is in, a page more than is in hand, or the bar's count if that is more.
    function pages() {
      var n = whole ? all.length : Math.max(all.length + 1, guess);
      return Math.max(1, Math.ceil(n / WALL_PRESS));
    }

    return {
      page: function (p) {
        var need = p * WALL_PRESS;
        var ready = all.length >= need || whole ? Promise.resolve() : new Promise(function (done, fail) {
          waiters.push({ need: need, done: done, fail: fail });
          load().catch(function () {});
        });
        return ready.then(function () {
          var last = pages();
          if (p > last) p = last;
          return { page: p, pages: last, rows: all.slice((p - 1) * WALL_PRESS, p * WALL_PRESS) };
        });
      },
      pages: pages,
      warm: function () { load().catch(function () {}); }
    };
  }

  /* ---- A product page's review band: that product's own reviews only. ----
   * Lorenzo, 26 October 2026: "a product with no reviews of its own should show no reviews",
   * so a product with none in our copy loses the band, instead of Fera's borrowed ones.
   * HOW MANY SHOW IS AS BEFORE (his 16 and 19 October choices for the ring page): three, then
   * "View more" on a phone; three to a page with numbered pages from 769px. The words are cut
   * to --sp-rev-lines with "Read more", and three photos show until it is pressed. */

  function mountBand(band, info) {
    if (!band || band.getAttribute('data-sp-rv-bound')) return;
    band.setAttribute('data-sp-rv-bound', '1');
    var html = document.documentElement;
    var PER = 3, CHUNK = 30, STEP = 10;
    var all = [], total = null, chunks = 0, page = 1, phoneShown = PER, drawn = false, mode = null;
    var ours = ourProduct(info.id);   // our copy, or null when the page still reads Fera

    var inner = band.querySelector('.sesto-reviews__inner') || band;
    var anchor = band.querySelector('.sesto-reviews__app-wrap');
    var box = document.createElement('div');
    box.className = 'sp-rv sp-rv--band';
    box.innerHTML =
      '<div class="sp-rv__head" hidden></div>' +
      '<p class="sp-rv__status" role="status">Loading reviews&hellip;</p>' +
      '<div class="sp-rv__list"></div>' +
      '<nav class="sp-rv__pager" aria-label="Review pages" hidden></nav>' +
      '<div class="sp-rv__foot" hidden><button type="button" class="btn btn--secondary sp-rv__more">View more <span aria-hidden="true">&rarr;</span></button></div>' +
      '<p class="sp-rv__error" role="status" hidden>The next reviews could not be loaded. Please try again.</p>';
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor);
    else inner.appendChild(box);

    var head = box.querySelector('.sp-rv__head');
    var status = box.querySelector('.sp-rv__status');
    var list = box.querySelector('.sp-rv__list');
    var pager = box.querySelector('.sp-rv__pager');
    var foot = box.querySelector('.sp-rv__foot');
    var more = box.querySelector('.sp-rv__more');
    var error = box.querySelector('.sp-rv__error');

    function giveUp() {
      html.classList.remove('sp-rv-band-wait');
      if (box.parentNode) box.parentNode.removeChild(box);
    }
    setTimeout(function () { if (!drawn) giveUp(); }, 16000);

    function desktop() { return !!(window.matchMedia && window.matchMedia('(min-width: 769px)').matches); }
    function count() { return total != null ? total : all.length; }

    // Fetch 30 at a time until at least n are in hand or there are no more.
    function ensure(n) {
      if (all.length >= n || (total != null && all.length >= total)) return Promise.resolve();
      return fetchPage({ productId: info.id, page: chunks + 1, limit: CHUNK }).then(function (res) {
        chunks += 1;
        if (res.total != null) total = res.total;
        all = all.concat(res.rows);
        if (res.rows.length < CHUNK) total = all.length;
        return ensure(n);
      });
    }

    function cards(rows) {
      return rows.map(function (r) { return cardHTML(r, { clamp: true, photoCap: 3 }); }).join('');
    }

    function render() {
      mode = desktop() ? 'desk' : 'phone';
      error.hidden = true;
      if (mode === 'desk') {
        var pages = Math.max(1, Math.ceil(count() / PER));
        if (page > pages) page = pages;
        list.innerHTML = cards(all.slice((page - 1) * PER, page * PER));
        foot.hidden = true;
        pager.hidden = pages < 2;
        pager.innerHTML = pages < 2 ? '' : pagerHTML(page, pages);
      } else {
        list.innerHTML = cards(all.slice(0, phoneShown));
        pager.hidden = true;
        foot.hidden = phoneShown >= count();
      }
      measureClamps(list);
    }

    pager.addEventListener('click', function (e) {
      var b = e.target.closest('.sp-rv__page');
      if (!b || b.disabled) return;
      var p = parseInt(b.getAttribute('data-page'), 10);
      if (!p || p === page) return;
      ensure(p * PER).then(function () { page = p; render(); }).catch(function () { error.hidden = false; });
    });

    more.addEventListener('click', function () {
      more.disabled = true;
      var want = phoneShown + STEP;
      ensure(want).then(function () { phoneShown = want; render(); })
        .catch(function () { error.hidden = false; })
        .then(function () { more.disabled = false; });
    });

    var resizeT = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () { if (drawn && (desktop() ? 'desk' : 'phone') !== mode) render(); }, 150);
    });

    function mean(rows) {
      var s = 0;
      rows.forEach(function (r) { s += r.rating; });
      return rows.length ? s / rows.length : NaN;
    }

    // THE AVERAGE IS COUNTED FROM THE REVIEWS THEMSELVES, so the stars fill to the exact figure.
    // Shopify keeps a product's average to one decimal (Fera's reviews.rating, and our
    // sesto_reviews.rating too: The Quest's 332 read "5.0"), which is why it is counted here.
    // The number printed is the true one, two decimals (avgText; Lorenzo, 30 October: "Lets show
    // the true average"), so The Quest's 4.947 reads 4.95.
    // A product with 30 reviews or fewer has them all in hand after the first fetch. A bigger one
    // asks for the rest, 100 at a time (measured for The Quest: 4 asks, about 2 seconds), and the
    // number stays hidden until it is known. If that fails, the stored figure is used.
    function exactAverage() {
      var pages = Math.ceil(count() / 100), jobs = [];
      for (var p = 1; p <= pages; p++) jobs.push(fetchPage({ productId: info.id, page: p, limit: 100 }));
      return Promise.all(jobs).then(function (res) {
        var rows = [];
        res.forEach(function (x) { rows = rows.concat(x.rows); });
        return mean(rows);
      });
    }

    function drawHead() {
      var stored = parseFloat(info.avg);
      if (isNaN(stored) && !ours) {
        var sum = document.querySelector('[data-sp-rv-sum][data-rating-average]');
        stored = sum ? parseFloat(sum.getAttribute('data-rating-average')) : NaN;
      }
      var n = count();
      var inHand = all.length >= n;
      var avg = inHand ? mean(all) : stored;
      if (isNaN(avg)) avg = mean(all) || 0;
      head.innerHTML =
        '<div class="sp-rv__score"' + (inHand ? '' : ' style="visibility:hidden"') + '>' + avgText(avg) + '</div>' +
        '<div class="sp-rv__head-mid">' + avgStarsHTML(avg) +
          '<p class="sp-rv__based">Based on ' + n.toLocaleString('en-US') + (n === 1 ? ' review' : ' reviews') + '</p></div>' +
        (writeOn()
          ? '<span class="sp-rv__break" aria-hidden="true"></span>' +
            '<button type="button" class="btn sp-rv__write">' + esc(WORDS.open) + '</button>'
          : '');
      head.hidden = false;
      if (inHand && ours) paintSummary(ours, avg, n);
      if (!inHand) {
        var score = head.querySelector('.sp-rv__score'), done = false;
        var show = function (a) {
          if (done) return;
          done = true;
          if (isNaN(a)) {
            a = stored;
            if (isNaN(a)) a = mean(all) || 0;
          }
          score.textContent = avgText(a);
          var stars = head.querySelector('.sp-rv__avg');
          if (stars) stars.outerHTML = avgStarsHTML(a);
          score.style.visibility = '';
          if (ours) paintSummary(ours, a, n);
        };
        exactAverage().then(show, function () { show(NaN); });
        setTimeout(function () { show(NaN); }, 10000);
      }
      // THE PRESS. Our own form, in a dialog over the page, so nothing on the page
      // moves (openForm at the foot of this file). The button is drawn only when the
      // switch is on, so there is nothing here to unhide.
      var write = head.querySelector('.sp-rv__write');
      if (write) {
        write.addEventListener('click', function () {
          openForm({ kind: 'product', productId: String(info.id), button: write });
        });
      }
    }

    // Our copy needs no Fera key, and a product with none in it has no reviews of its own.
    (ours ? Promise.resolve(true) : waitForKey(15000)).then(function (key) {
      if (!key) throw new Error('no key');
      if (ours && !(Number(ours.count) > 0)) return;
      return ensure(PER);
    }).then(function () {
      drawn = true;
      if (!all.length) {
        // No reviews of its own: no band at all.
        var sec = band.closest('.shopify-section') || band;
        sec.style.display = 'none';
        html.classList.remove('sp-rv-band-wait');
        return;
      }
      status.hidden = true;
      drawHead();
      render();
      html.classList.add('sp-rv-band-on');
      html.classList.remove('sp-rv-band-wait');
    }).catch(giveUp);
  }

  /* ---- The stars by the price. ----
   * OURS SINCE 1 November 2026 (issue #68). They were Fera's own block
   * (product_reviews_summary) until today, drawn by the app and then written over with our
   * figures here. The app is being uninstalled, so snippets/product-template.liquid now
   * prints the element itself, from sesto_reviews.rating and sesto_reviews.count, and this
   * replaces the stored average (one decimal) with the true one as soon as the band below has
   * counted it (Lorenzo, 30 October 2026: "Lets show the true average"). A product with none
   * in our copy has no element at all (Lorenzo, 26 October). The look is Fera's, kept: the
   * same typed stars in the same gold, in assets/custom.css. Pressed, they take you down to
   * the reviews (goToReviews).
   * NOTHING WATCHES THE ELEMENT ANY MORE. There used to be a MutationObserver on it, because
   * Fera would paint its own numbers back over ours and the page must never show two. Ours is
   * written once by the server and only ever touched here. */
  function paintSummary(p, avg, n) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sp-rv-sum]'), function (el) {
      var pid = el.getAttribute('data-product-id');
      if (pid && pid !== String(p.id)) return;
      el.spRvSum = { avg: Number(avg) || 0, n: Number(n) || 0 };
      applySummary(el);
    });
    document.documentElement.classList.remove('sp-rv-sum-wait');
  }

  // Sets only what differs, so nothing is written twice. The element is
  // snippets/product-template.liquid's; the gold row is clipped to the average by its width,
  // which is how Fera drew it too, and the count is the number inside the brackets that
  // assets/custom.css puts round it.
  function applySummary(el) {
    var s = el.spRvSum;
    if (!s) return;
    function set(node, attr, v) { if (node && node.getAttribute(attr) !== v) node.setAttribute(attr, v); }
    function text(node, v) { if (node && node.textContent !== v) node.textContent = v; }
    if (!s.n) { if (el.style.display !== 'none') el.style.display = 'none'; return; }
    var avg = avgText(s.avg), n = String(s.n);
    // A link down to the reviews (goToReviews, below), wherever it shows a count.
    set(el, 'data-sp-rv-link', '');
    set(el, 'role', 'link');
    set(el, 'tabindex', '0');
    set(el, 'aria-label', 'Read the reviews (' + n + ')');
    if (el.style.cursor !== 'pointer') el.style.cursor = 'pointer';
    var pct = (Math.max(0, Math.min(5, s.avg)) / 5 * 100).toFixed(1) + '%';
    set(el, 'data-rating-count', n);
    set(el, 'data-rating-average', avg);
    var fill = el.querySelector('.sp-rvsum__fill');
    if (fill && fill.style.width !== pct) fill.style.width = pct;
    text(el.querySelector('.sp-rvsum__n'), n);
  }

  /* ---- The stars by the price take you down to the reviews. ----
   * Lorenzo, 29 October 2026: "In every product page (new ring, momorial, custom, moss agate) make
   * the reviews under the price clicable and scrolls down to where the reviews are". The stars are
   * moved into whichever title row fits the screen by the ring page's own script (the desktop one
   * or the phone one), so the press is caught here, for the whole page, and not on one element.
   * applySummary() marks the element as a link wherever it shows a count. It lands on the top of
   * the reviews section, its own space above the heading included; no header stays stuck over the
   * page on these templates (measured at 375 and 1280), so nothing is allowed for. */
  var SUM_LINK = '[data-sp-rv-sum][data-sp-rv-link]';
  function goToReviews(byKey) {
    var band = document.querySelector('.sesto-reviews');
    if (!band) return false;
    var target = band.closest('.shopify-section') || band;
    var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    function go(how) { window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset, behavior: how }); }
    go(smooth ? 'smooth' : 'auto');
    // Pictures above can finish loading on the way down and push the reviews lower. Once the scroll
    // has stopped, finish the last stretch - unless the visitor has scrolled well away meanwhile.
    var done = false;
    function settle() {
      if (done) return;
      done = true;
      window.removeEventListener('scrollend', settle);
      var off = target.getBoundingClientRect().top;
      if (Math.abs(off) > 4 && Math.abs(off) < window.innerHeight) go('auto');
      if (byKey) {
        var h = band.querySelector('.sesto-reviews__heading') || band;
        if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
        try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); }
      }
    }
    window.addEventListener('scrollend', settle);
    setTimeout(settle, 1500);
    return true;
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest(SUM_LINK);
    if (s && goToReviews(false)) e.preventDefault();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var s = e.target.closest && e.target.closest(SUM_LINK);
    if (s && s === e.target && goToReviews(true)) e.preventDefault();
  });

  function boot() {
    mountWriteButtons();
    Array.prototype.forEach.call(document.querySelectorAll('[data-sp-rv-page]'), mountPageList);
    var info = window.SpReviewUIProduct;
    var ours = info && info.id ? ourProduct(info.id) : null;
    // The count is on the page already; the stored average (one decimal) stands until the band
    // has counted the exact one.
    if (ours) paintSummary(ours, Number(ours.count) > 0 ? parseFloat(ours.avg) : 0, Number(ours.count) || 0);
    if (info && info.id) Array.prototype.forEach.call(document.querySelectorAll('.sesto-reviews'), function (b) { mountBand(b, info); });
  }

  /* ---- Our own "Write a review" form. ---- */
  //
  // A dialog over the page, so nothing on the page moves when it opens (the ring page's
  // phone layout is frozen). Written in the same plain ES5 as the rest of this file, so an
  // old iPhone draws it. Every word a customer can read is in WORDS below, in one place.
  //
  // It talks to reviews-submit twice: `start`, which answers a token and one signed upload
  // address per photograph, then `submit`. The photographs go straight from the browser to
  // the private holding bucket at the addresses the door hands over - no key of ours is in
  // this file, and nothing a stranger uploads is on the website even for a moment.
  //
  // A DOUBLE PRESS CANNOT SEND TWICE: the button is disabled on the first press and the
  // whole send is behind `sending`. Clarity shows a customer pressing Submit twice
  // (recording 1nob6gm/1d6llkd, 31 October), which is why that is said twice here and
  // again in the database.
  //
  // THE SAME THANK-YOU EITHER WAY, in the door's own words, so the form never reveals
  // whether an address is one of our customers'.

  var WORDS = {
    open:        'Write a review',
    heading:     'Write a review',
    about:       'Your review of ',
    shop:        'Sesto Synergy',
    rating:      'Your rating',
    stars:       ['1 star', '2 stars', '3 stars', '4 stars', '5 stars'],
    headline:    'Headline',
    optional:    '(optional)',
    review:      'Your review',
    name:        'Your name',
    email:       'Your email',
    emailHelp:   'We only use this to find your order. It is never shown on the site.',
    photos:      'Photos',
    photosHelp:  'Up to 5. A JPEG, PNG or WebP.',
    addPhotos:   'Add photos',
    removePhoto: 'Remove',
    send:        'Send review',
    sending:     'Sending…',
    close:       'Close',
    noRating:    'Please choose a star rating.',
    noReview:    'Please write your review.',
    noName:      'Please tell us your name.',
    badEmail:    'Please check your email address.',
    tooMany:     'You can add up to 5 photos.',
    badPhoto:    'Photos only, please - a JPEG, PNG or WebP.',
    tooBig:      'One of your photos is over 15 MB. Please remove it and try again.',
    noDoor:      'Sorry, we could not send your review just now. Please try again in a moment.'
  };
  var PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
  var PHOTO_MAX = 5;
  var PHOTO_BYTES = 15 * 1024 * 1024;

  var form = null, formAbout = null, formKind = 'store', formProduct = null;
  var opener = null, openedAt = 0, sending = false, chosen = [];

  function ringName() {
    var og = document.querySelector('meta[property="og:title"]');
    if (og && og.content) return String(og.content).trim();
    var h1 = document.querySelector('h1');
    return h1 ? String(h1.textContent || '').trim() : '';
  }

  function build() {
    var box = document.createElement('div');
    box.className = 'sp-rf';
    box.hidden = true;
    box.innerHTML =
      '<div class="sp-rf__sheet" role="dialog" aria-modal="true" aria-labelledby="sp-rf-h">' +
        '<button type="button" class="sp-rf__x" aria-label="' + WORDS.close + '">&times;</button>' +
        '<h2 class="sp-rf__h" id="sp-rf-h">' + esc(WORDS.heading) + '</h2>' +
        '<p class="sp-rf__about"></p>' +
        '<form class="sp-rf__form" novalidate>' +
          '<fieldset class="sp-rf__stars">' +
            '<legend>' + esc(WORDS.rating) + '</legend>' +
            '<div class="sp-rf__starrow">' +
              WORDS.stars.map(function (label, i) {
                var n = i + 1;
                return '<input type="radio" name="sp-rf-rating" id="sp-rf-s' + n + '" value="' + n + '">' +
                       '<label for="sp-rf-s' + n + '" title="' + label + '">' +
                         '<span class="sp-rf__star" aria-hidden="true">★</span>' +
                         '<span class="sp-rf__sr">' + label + '</span></label>';
              }).join('') +
            '</div>' +
          '</fieldset>' +
          '<label class="sp-rf__lab" for="sp-rf-title">' + esc(WORDS.headline) +
            ' <span class="sp-rf__opt">' + esc(WORDS.optional) + '</span></label>' +
          '<input class="sp-rf__in" id="sp-rf-title" type="text" maxlength="200" autocomplete="off">' +
          '<label class="sp-rf__lab" for="sp-rf-body">' + esc(WORDS.review) + '</label>' +
          '<textarea class="sp-rf__in sp-rf__area" id="sp-rf-body" rows="5" maxlength="5000"></textarea>' +
          '<label class="sp-rf__lab" for="sp-rf-name">' + esc(WORDS.name) + '</label>' +
          '<input class="sp-rf__in" id="sp-rf-name" type="text" maxlength="200" autocomplete="name">' +
          '<label class="sp-rf__lab" for="sp-rf-email">' + esc(WORDS.email) + '</label>' +
          '<input class="sp-rf__in" id="sp-rf-email" type="email" maxlength="320" autocomplete="email" ' +
            'aria-describedby="sp-rf-email-help" inputmode="email">' +
          '<p class="sp-rf__help" id="sp-rf-email-help">' + esc(WORDS.emailHelp) + '</p>' +
          '<span class="sp-rf__lab">' + esc(WORDS.photos) +
            ' <span class="sp-rf__opt">' + esc(WORDS.optional) + '</span></span>' +
          '<label class="sp-rf__file">' + esc(WORDS.addPhotos) +
            '<input type="file" accept="' + PHOTO_TYPES.join(',') + '" multiple></label>' +
          '<p class="sp-rf__help">' + esc(WORDS.photosHelp) + '</p>' +
          '<ul class="sp-rf__list"></ul>' +
          // A field people never see. aria-hidden as well as off-screen, so a screen
          // reader never offers it either; only something filling in every input gets
          // caught, which is the point.
          '<div class="sp-rf__hp" aria-hidden="true">' +
            '<label for="sp-rf-website">Website</label>' +
            '<input id="sp-rf-website" name="website" type="text" tabindex="-1" autocomplete="off">' +
          '</div>' +
          '<p class="sp-rf__err" role="alert" hidden></p>' +
          '<button type="submit" class="btn sp-rf__send">' + esc(WORDS.send) + '</button>' +
        '</form>' +
        '<div class="sp-rf__done" hidden>' +
          '<p class="sp-rf__done-text" role="status"></p>' +
          '<button type="button" class="btn btn--secondary sp-rf__done-x">' + esc(WORDS.close) + '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(box);

    box.querySelector('.sp-rf__x').addEventListener('click', closeForm);
    box.querySelector('.sp-rf__done-x').addEventListener('click', closeForm);
    // The dark outside closes it; a press inside the sheet does not.
    box.addEventListener('click', function (e) { if (e.target === box) closeForm(); });
    box.querySelector('.sp-rf__file input').addEventListener('change', photosPicked);
    // The stars are a real radio group, so the arrow keys already work and a screen
    // reader reads "3 stars". Which ones are gold is painted here rather than with a
    // sibling selector, because that would need the row written backwards in the markup
    // and the arrow keys would then run the wrong way.
    Array.prototype.forEach.call(box.querySelectorAll('input[name="sp-rf-rating"]'), function (r) {
      r.addEventListener('change', paintStars);
    });
    box.querySelector('.sp-rf__form').addEventListener('submit', function (e) {
      e.preventDefault();
      send();
    });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeForm(); return; }
      if (e.key !== 'Tab') return;
      // Focus stays inside the dialog.
      var able = box.querySelectorAll('button, input, textarea, [href]');
      var able2 = [];
      Array.prototype.forEach.call(able, function (el) {
        if (!el.disabled && el.tabIndex !== -1 && el.offsetParent !== null) able2.push(el);
      });
      if (!able2.length) return;
      var first = able2[0], last = able2[able2.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    return box;
  }

  function photosPicked(e) {
    var picked = Array.prototype.slice.call(e.target.files || []);
    for (var i = 0; i < picked.length; i++) {
      if (chosen.length >= PHOTO_MAX) { say(WORDS.tooMany); break; }
      chosen.push(picked[i]);
    }
    e.target.value = '';
    drawPhotos();
  }

  function drawPhotos() {
    var list = form.querySelector('.sp-rf__list');
    list.innerHTML = chosen.map(function (f, i) {
      return '<li><span>' + esc(f.name) + '</span>' +
        '<button type="button" class="sp-rf__drop" data-i="' + i + '">' + esc(WORDS.removePhoto) + '</button></li>';
    }).join('');
    Array.prototype.forEach.call(list.querySelectorAll('.sp-rf__drop'), function (b) {
      b.addEventListener('click', function () {
        chosen.splice(Number(b.getAttribute('data-i')), 1);
        drawPhotos();
      });
    });
    form.querySelector('.sp-rf__file').hidden = chosen.length >= PHOTO_MAX;
  }

  function paintStars() {
    var n = rating();
    Array.prototype.forEach.call(form.querySelectorAll('.sp-rf__starrow label'), function (l, i) {
      if (i < n) l.className = 'is-on'; else l.className = '';
    });
  }

  function say(text) {
    var p = form.querySelector('.sp-rf__err');
    p.textContent = text || '';
    p.hidden = !text;
  }

  function openForm(o) {
    if (!form) form = build();
    formKind = o && o.kind === 'product' ? 'product' : 'store';
    formProduct = o && o.productId ? String(o.productId) : null;
    formAbout = formKind === 'product' ? (ringName() || WORDS.shop) : WORDS.shop;
    opener = (o && o.button) || null;
    chosen = [];
    sending = false;

    form.querySelector('.sp-rf__about').textContent = WORDS.about + formAbout;
    form.querySelector('.sp-rf__form').hidden = false;
    form.querySelector('.sp-rf__done').hidden = true;
    form.querySelector('#sp-rf-title').value = '';
    form.querySelector('#sp-rf-body').value = '';
    form.querySelector('#sp-rf-name').value = '';
    form.querySelector('#sp-rf-email').value = '';
    form.querySelector('#sp-rf-website').value = '';
    Array.prototype.forEach.call(form.querySelectorAll('input[name="sp-rf-rating"]'), function (r) { r.checked = false; });
    var sendBtn = form.querySelector('.sp-rf__send');
    sendBtn.disabled = false;
    sendBtn.textContent = WORDS.send;
    say('');
    paintStars();
    drawPhotos();

    form.hidden = false;
    document.documentElement.classList.add('sp-rf-on');
    openedAt = Date.now();
    form.querySelector('#sp-rf-s5').focus();
  }

  function closeForm() {
    if (!form) return;
    form.hidden = true;
    document.documentElement.classList.remove('sp-rf-on');
    // Focus goes back to the button that opened it.
    if (opener && opener.focus) opener.focus();
    opener = null;
  }

  function rating() {
    var r = form.querySelector('input[name="sp-rf-rating"]:checked');
    return r ? Number(r.value) : 0;
  }

  /** The same shape the database tests for, so the form and the door agree. */
  function emailish(v) {
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(v || '').trim());
  }

  function send() {
    if (sending) return;                       // the second press of a double press
    var stars = rating();
    var body = form.querySelector('#sp-rf-body').value;
    var name = form.querySelector('#sp-rf-name').value;
    var email = form.querySelector('#sp-rf-email').value;

    if (!stars) { say(WORDS.noRating); form.querySelector('#sp-rf-s5').focus(); return; }
    if (!String(body).trim()) { say(WORDS.noReview); form.querySelector('#sp-rf-body').focus(); return; }
    if (!String(name).trim()) { say(WORDS.noName); form.querySelector('#sp-rf-name').focus(); return; }
    if (!emailish(email)) { say(WORDS.badEmail); form.querySelector('#sp-rf-email').focus(); return; }
    for (var i = 0; i < chosen.length; i++) {
      if (PHOTO_TYPES.indexOf(String(chosen[i].type || '').toLowerCase()) < 0) { say(WORDS.badPhoto); return; }
      if (chosen[i].size > PHOTO_BYTES) { say(WORDS.tooBig); return; }
    }
    if (chosen.length > PHOTO_MAX) { say(WORDS.tooMany); return; }

    sending = true;
    say('');
    var button = form.querySelector('.sp-rf__send');
    button.disabled = true;
    button.textContent = WORDS.sending;
    var letGo = function (text) {
      sending = false;
      button.disabled = false;
      button.textContent = WORDS.send;
      say(text);
    };

    door({
      action: 'start',
      rating: stars,
      title: form.querySelector('#sp-rf-title').value,
      review: body,
      name: name,
      email: email,
      kind: formKind,
      product_id: formProduct,
      photos: chosen.map(function (f) { return { name: f.name, type: f.type, size: f.size }; }),
      website: form.querySelector('#sp-rf-website').value,
      elapsed_ms: Date.now() - openedAt,
      page: location.pathname
    }).then(function (started) {
      if (!started || started.ok !== true) throw doorError(started && started.error);
      var uploads = started.uploads || [];
      // Each photograph straight to the address the door signed for it. A photograph that
      // will not go up does not stop the review: it is the review that matters, and the
      // database keeps that picture marked as still to copy.
      var jobs = uploads.map(function (u) {
        var file = chosen[u.index];
        if (!file) return Promise.resolve();
        return fetch(u.url, { method: 'PUT', headers: { 'content-type': u.type || file.type }, body: file })
          .catch(function () { /* said above */ });
      });
      return Promise.all(jobs).then(function () {
        return door({ action: 'submit', token: started.token, name: name });
      });
    }).then(function (sent) {
      if (!sent || sent.ok !== true) throw doorError(sent && sent.error);
      // THE DOOR'S OWN WORDS. The same sentence whether or not the email matched an order.
      form.querySelector('.sp-rf__form').hidden = true;
      form.querySelector('.sp-rf__done-text').textContent = sent.message || '';
      form.querySelector('.sp-rf__done').hidden = false;
      form.querySelector('.sp-rf__done-x').focus();
      sending = false;
    }).catch(function (e) {
      // A sentence, never a code and never a stack. ONLY what the door itself wrote is
      // shown: a door that is not deployed yet, or a phone that lost its signal, lands
      // here with the browser's own words ("Failed to fetch"), and the customer gets ours.
      letGo(e && e.fromDoor && e.message ? String(e.message).slice(0, 240) : WORDS.noDoor);
    });
  }

  /** A refusal the DOOR wrote, which is already a sentence for a customer. Anything else
   *  that goes wrong - no signal, a door that is not deployed, a 500 that is an HTML page -
   *  is not, and must never be shown: "Failed to fetch" is the browser talking. */
  function doorError(message) {
    var e = new Error(message || WORDS.noDoor);
    e.fromDoor = !!message;
    return e;
  }

  function door(payload) {
    return fetch(FORM_DOOR, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().catch(function () { return null; });
    });
  }

  /** The button on /pages/reviews. The section prints it hidden; the switch decides. */
  function mountWriteButtons() {
    Array.prototype.forEach.call(document.querySelectorAll('.sp-rs__write'), function (b) {
      if (b.getAttribute('data-sp-rf-bound')) return;
      b.setAttribute('data-sp-rf-bound', '1');
      if (!writeOn()) return;
      b.hidden = false;
      b.addEventListener('click', function () { openForm({ kind: 'store', button: b }); });
    });
  }

  window.SpReviewUI = {
    LABEL: LABEL,
    isLetterCircle: isLetterCircle,
    fetchPage: fetchPage,
    waitForKey: waitForKey,
    toReview: toReview,
    ourReview: ourReview,
    cardHTML: cardHTML,
    avgText: avgText,
    starsHTML: starsHTML,
    avgStarsHTML: avgStarsHTML,
    measureClamps: measureClamps,
    mountPageList: mountPageList,
    mountBand: mountBand,
    // Our own review form: whether the button shows, and how to open it.
    writeAReviewOn: writeOn,
    openReviewForm: openForm,
    reviewFormWords: WORDS
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
